import { useEffect, useState } from 'react';
import DeviceDataTable from './components/DeviceDataTable';
import DeviceDataTiles from './components/DeviceDataTiles';
import BackButton from '../../Home/components/KnowledgeCentre/BackButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import CustomDropDownInput from 'packages/novous_web/src/common/components/customDropDownInput';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import BackIcon from 'packages/novous_web/src/assets/icons/ArrowLeft.svg';

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

export default function Devices() {
  const navigate = useNavigate();
  const [tileData, setTilesData] = useState<ColumnObjType>();
  const [allDeviceData, setAllDeviceData] = useState<any>(null);
  const { user } = useAuth();
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);

  const handleTiles = (data: ColumnObjType) => {
    setTilesData(data);
  };

  const handleAllDeviceData = (data: any) => {
    setAllDeviceData(data);
  };

  const location = useLocation();
  const selectedGroup = location.state?.selectedGroup || null;
  const initialDeviceTilesCount = location.state?.initialDeviceTilesCount;

  // Restore selectedCompany and selectedUser from location state when coming back from DeviceDetails
  useEffect(() => {
    if (location.state?.selectedCompany || location.state?.selectedUser) {
      setSelectedCompany(location.state?.selectedCompany || null);
      setSelectedUser(location.state?.selectedUser || null);
    }
  }, [location.state?.selectedCompany, location.state?.selectedUser]);

  const backNavigate = () => {
    if (selectedGroup) {
      navigate('/dashboard', { state: { selectedGroup } });
    } else {
      navigate('/dashboard');
    }
  };

  const {
    data: companyList,
    error: companyListError,
    loading: companyListLoading,
    fetchData: fetchCompanyListData,
  } = useAxios<any>(`${API_ENDPOINTS.users.COMPANY_LIST}`, 'GET');

  const {
    data: companyListByCrn,
    error: companyListByCrnError,
    loading: companyListByCrnLoading,
    fetchData: fetchCompanyListByCrnData,
  } = useAxios<any>(`${API_ENDPOINTS.users.CUSTOMER_LIST_CRN}`, 'POST');

  useEffect(() => {
    if (user?.authorities === 'ROLE_SUPER_ADMIN') {
      fetchCompanyListData();
    }
  }, [user]);

  useEffect(() => {
    if (user?.authorities === 'ROLE_SUPER_ADMIN' && selectedCompany) {
      fetchCompanyListByCrnData({
        userId: selectedCompany?.id,
        userCrn: selectedCompany?.crn,
      });
    }
  }, [user, selectedCompany]);

  const companyOptions =
    companyList?.data?.map((company: any) => ({
      label: company.name,
      value: company.id,
    })) || [];

  const handleCompanyChange = (value: string) => {
    const companySelected = companyList?.data?.find((company: any) => company.id === value);
    setSelectedCompany(companySelected || null);
    setSelectedUser(null);
  };

  const handleUserChange = (value: string) => {
    const userSelected = companyListByCrn?.data?.find((u: any) => u.fullName === value);
    setSelectedUser(userSelected || null);
  };

  return (
    <div className="flex flex-col gap-4">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <button
          className="flex items-center"
          onClick={backNavigate}
          style={{
            fontFamily: 'Inter Tight',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#5547DD',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <img src={BackIcon} alt="back" width={24} height={24} style={{ marginRight: '4px' }} /> Back
        </button>
        {user.authorities === 'ROLE_SUPER_ADMIN' && (
          <Box className="flex justify-end items-center gap-4" sx={{ flex: 1 }}>
            <CustomDropDownInput
              label="Select Company"
              options={companyOptions}
              value={selectedCompany?.id || ''}
              onChange={handleCompanyChange}
              placeholder="Select Company"
              showDropdownArrow={true}
              isMandatory
            />
            <CustomDropDownInput
              label="Select Customer"
              options={
                companyListByCrn?.data?.map((user: any) => ({
                  value: user.fullName,
                  label: user.fullName,
                })) || []
              }
              value={selectedUser?.fullName || ''}
              onChange={handleUserChange}
              placeholder="Select Customer"
              showDropdownArrow={true}
              isDisabled={!selectedCompany}
              isMandatory
            />
          </Box>
        )}
      </Box>
      <div className="flex-1">
        <DeviceDataTiles
          data={tileData}
          selectedGroup={selectedGroup}
          allDeviceData={allDeviceData}
          selectedUser={selectedUser}
          initialDeviceTilesCount={initialDeviceTilesCount}
        />
      </div>
      <div className="flex-1 tripTable">
        <DeviceDataTable
          handleTile={handleTiles}
          selectedGroup={selectedGroup}
          onAllDeviceDataFetch={handleAllDeviceData}
          selectedUser={selectedUser}
          selectedCompany={selectedCompany}
        />
      </div>
    </div>
  );
}
